"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.Header = exports.CardHeader = exports.CardBody = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Title = _interopRequireDefault(require("../Text/Title"));

var CardHeader = _styledComponents.default.div.withConfig({
  componentId: "sc-1515sla-0"
})(["", " border-bottom:1px solid #dbdfe5;"], function (_ref) {
  var paddingType = _ref.paddingType,
      paddingSize = _ref.paddingSize,
      radius = _ref.radius;
  return "\n    padding-top: ".concat(_elements.boxPadding[paddingType][paddingSize].top, "px;\n    padding-right: ").concat(_elements.boxPadding[paddingType][paddingSize].right, "px;\n    padding-bottom: ").concat(_elements.boxPadding[paddingType][paddingSize].bottom, "px;\n    padding-left: ").concat(_elements.boxPadding[paddingType][paddingSize].left, "px;\n    border-radius: ").concat(_tokens.borderRadius[radius], "px;\n  ");
});

exports.CardHeader = CardHeader;
var Header = (0, _styledComponents.default)(_Title.default).attrs({
  size: 'body01Bold'
}).withConfig({
  componentId: "sc-1515sla-1"
})(["display:flex;"]);
exports.Header = Header;

var Icon = _styledComponents.default.i.withConfig({
  componentId: "sc-1515sla-2"
})(["display:inline-flex;align-self:center;width:", "px;height:", "px;margin-right:", "px;transition:0.2s all linear;& svg{fill:", ";width:16px;height:16px;}&.right{margin-left:4px;}"], _tokens.spacing.horizontal.xs, _tokens.spacing.vertical.xs, _tokens.spacing.horizontal.xs, _tokens.colors.neutral500);

exports.Icon = Icon;

var CardBody = _styledComponents.default.div.withConfig({
  componentId: "sc-1515sla-3"
})(["line-height:1;"]);

exports.CardBody = CardBody;